import { RequireCapability } from "@/components/RequireCapability";
import { RequireSubscription } from "@/components/RequireSubscription";

import { ActionPlansApp } from "./components/ActionPlansApp";
// Registers the slice's actionPlans.* translations (side-effect import).
import "./i18n";

/**
 * Action plans area (route: /action-plans). Plan list + the five-step workspace
 * — issue selection, action selection, bonus goals/actions, prioritization and
 * tracking — built on the action-plans API merged in Wave 1. Every editable
 * form autosaves on change with a visible <SaveStatus>.
 */
export function ActionPlansPage() {
  return (
    <RequireCapability required={["authenticated"]}>
      <RequireSubscription>
        <ActionPlansApp />
      </RequireSubscription>
    </RequireCapability>
  );
}
